<template>
  <v-chip
    :color="chipClass"
    class="white--text font-weight-bold caption text-uppercase text-center state-chip"
    v-html="$t(`appointments.statuses-short.${chipLabel}`)"
  ></v-chip>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      required: false
    },
    acceptedToWork: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    chipLabel() {
      if (this.state === "ACCEPTED") {
        if (this.acceptedToWork) {
          return "ACCEPTED";
        } else {
          return "ACCEPTED_POST";
        }
      }
      return this.state;
    },
    chipClass() {
      switch (this.state) {
        case "ACCEPTED":
        case "ACCEPTED_POST":
        case "INBILL":
        case "DONE":
        case "DONE_NOTBILLABLE":
          return "success";
        case "PENDING":
        case "TOBERESCHEDULED":
        case "MEMBERCHANGE":
        case "ADMINISTRATIVE_CHECK_REQUIRED":
          return "warning";
        case "REQUESTCANCELLEDBYNEST":
        case "REQUESTCANCELLEDBYMEMBER":
        case "REQUESTCANCELLEDBYPORTAL":
        case "APPOINTMENTCANCELLEDBYNEST":
        case "APPOINTMENTCANCELLEDBYMEMBER":
        case "APPOINTMENTCANCELLEDBYPORTAL":
        case "APPOINTMENTCANCELLEDCONFIRMED":
        case "NOTDONE":
        case "NOT_DELIVERABLE_BY_FE":
          return "error";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.state-chip {
  height: auto;
  min-height: 24px;
}
.state-chip >>> .v-chip__content {
  height: auto !important;
  max-width: 100%;
  white-space: pre-wrap;
}
</style>
